import { FileExtension } from "@inrev/common";
import { CustomFileIcon } from "../ui/CustomFileIcon";
import { Spinner } from "../ui/Spinner";

/**
 * @deprecated Use `<Card elevation="raised">` from
 * `@portal/components/primitives/Card` instead. Part of the card consolidation.
 */
export const AttachmentFileCardLayout = ({
	fileExtension,
	headerSection,
	subHeaderSection,
	tagSection,
	actionSection,
	isLoading,
}: {
	fileExtension: FileExtension;
	headerSection: React.ReactNode;
	subHeaderSection?: React.ReactNode;
	tagSection: React.ReactNode;
	actionSection: React.ReactNode;
	isLoading: boolean;
}) => {
	return (
		<div className="w-full flex items-center justify-center p-[15px] bg-white border border-gray-200 rounded-[5px] shadow-sm text-[15px]">
			{isLoading ? (
				<Spinner />
			) : (
				<div className="h-full w-full flex gap-x-[25px] text-gray-800">
					<CustomFileIcon extension={fileExtension} />
					<div className="flex flex-col space-y-[12px] w-full">
						<div className="flex flex-col space-y-[4px]">
							<div className="text-primary text-[15px]">{headerSection}</div>
							<div className="text-tertiary text-[12px] flex gap-x-[40px]">{subHeaderSection}</div>
						</div>
						{tagSection}
					</div>
					<div className="flex items-start justify-center flex-row gap-x-[10px] flex-shrink-0">
						{actionSection}
					</div>
				</div>
			)}
		</div>
	);
};
